import { QRCodeCanvas } from "qrcode.react";
import { Trans, useTranslation } from "react-i18next";
import clsx from "classnames";
import { TypographyVariant } from "../../../constants/typography";
import { Typography } from "../../core/Typography/Typography";
import { Icon } from "../../core/Icon/Icon";
import { MAX_WIDTH_MOBILE } from "../../../constants/dimension";
import { TypePopup } from "../../../types/popup";
import { getSetupDevicesTitle } from "../../../models/media";
import { useStyles } from "./SetupDevicesPopup.style";

type ISetupDevicesPopupProps = {
  type: TypePopup;
};

export const SetupDevicesPopup: React.FC<ISetupDevicesPopupProps> = (props) => {
  const { type } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const isMobile = window.innerWidth <= MAX_WIDTH_MOBILE;

  const bold = (
    <Typography variant={TypographyVariant.BodyB3Bold} inline></Typography>
  );

  const getInstallText = () => {
    const key =
      type === "ios"
        ? "SetupDevicesPopup_2. Tap the <0>Share</0> button on the toolbar"
        : type === "osx"
        ? "SetupDevicesPopup_2. Select <0>Add to Dock</0> or <1>Install</1> on the toolbar"
        : "SetupDevicesPopup_2. Click button <0>Install Now</0>";

    return (
      <Typography variant={TypographyVariant.BodyB3Medium} textAlign="left">
        <Trans i18nKey={key} components={[bold, bold]} />
      </Typography>
    );
  };

  return (
    <>
      <div className={classes.header}>
        <Typography
          variant={
            isMobile
              ? TypographyVariant.BodyB2Bold
              : TypographyVariant.HeadingH3Bold
          }
        >
          {t(getSetupDevicesTitle(type))}
        </Typography>
      </div>
      <div className={classes.container}>
        <div className={classes.item}>
          <div className={classes.qrInner}>
            <QRCodeCanvas
              value={import.meta.env.VITE_APP_URL}
              bgColor="#FFFFFF"
              fgColor="#000000"
              level="L"
              className={classes.qrCode}
            />
          </div>
          <Typography variant={TypographyVariant.BodyB3Medium} textAlign="left">
            <Trans
              i18nKey={
                type === "ios"
                  ? "SetupDevicesPopup_1. Scan QR code or open <0>{{url}}</0> in Safari"
                  : "SetupDevicesPopup_1. Scan QR code or open <0>{{url}}</0>"
              }
              values={{
                url: import.meta.env.VITE_APP_URL.replace(/^https?:\/\//, ""),
              }}
              components={[
                <Typography
                  variant={TypographyVariant.BodyB3Medium}
                  inline
                  className={classes.link}
                ></Typography>,
              ]}
            />
          </Typography>
        </div>
        <div className={classes.item}>
          <Icon
            name={type === "ios" ? "icon-logout" : "icon-linear-add-square"}
            size={!isMobile ? 50 : 30}
            className={clsx(classes.icon, { ios: type === "ios" })}
          />
          {getInstallText()}
        </div>
        <div className={classes.item}>
          <Icon
            name={
              type === "ios"
                ? "icon-linear-add-square"
                : "icon-linear-tick-circle"
            }
            size={!isMobile ? 50 : 30}
            className={classes.icon}
          />
          <Typography variant={TypographyVariant.BodyB3Medium} textAlign="left">
            {type === "ios" ? (
              <Trans
                i18nKey="SetupDevicesPopup_3. Swipe up and select <0>Add to Home Screen</0> from the menu"
                components={[bold]}
              />
            ) : (
              t("SetupDevicesPopup_3. Accept system prompt")
            )}
          </Typography>
        </div>
        <div className={classes.item}>
          <Icon
            name="icon-tick"
            size={!isMobile ? 50 : 30}
            className={classes.icon}
          />
          <Typography variant={TypographyVariant.BodyB3Medium} textAlign="left">
            {type === "android" || type === "ios"
              ? t("SetupDevicesPopup_4. Open ONMO+ from your home screen")
              : t("SetupDevicesPopup_4. Open ONMO+ from your desktop")}
          </Typography>
        </div>
      </div>
    </>
  );
};
